const toolbarGroups = [
  [
    {
      id: 1,
      format: 'fontFamily',
      type: 'dropdown',
      options: [
        { text: 'Sans Serif', value: 'sans' },
        { text: 'Serif', value: 'serif' },
        { text: 'MonoSpace', value: 'monospace' },
      ],
    },
  ],
  [
    {
      id: 2,
      format: 'fontSize',
      type: 'dropdown',
      options: [
        { text: '8px', value: '8px' },
        { text: '10px', value: '10px' },
        { text: '12px', value: '12px' },
        { text: '14px', value: '14px' },
        { text: '16px', value: '16px' },
        { text: '18px', value: '18px' },
        { text: '24px', value: '24px' },
        { text: '32px', value: '32px' },
        { text: '48px', value: '48px' },
        { text: '60px', value: '60px' },
        { text: '72px', value: '72px' },
      ],
    },
  ],
  [
    {
      id: 3,
      format: 'bold',
      type: 'mark',
    },
    {
      id: 4,
      format: 'italic',
      type: 'mark',
    },
    {
      id: 5,
      format: 'underline',
      type: 'mark',
    },
    {
      id: 6,
      format: 'strikethrough',
      type: 'mark',
    },
  ],
  [
    {
      id: 7,
      format: 'color',
      type: 'color-picker',
    },
    {
      id: 8,
      format: 'bgColor',
      type: 'color-picker',
    },
  ],
  [
    {
      id: 9,
      format: 'superscript',
      type: 'mark',
    },
    {
      id: 10,
      format: 'subscript',
      type: 'mark',
    },
  ],
  // [
  //   {
  //     id: 11,
  //     format: 'headingOne',
  //     type: 'block',
  //   },
  //   {
  //     id: 12,
  //     format: 'headingTwo',
  //     type: 'block',
  //   },
  //   {
  //     id: 13,
  //     format: 'headingThree',
  //     type: 'block',
  //   },
  //   {
  //     id: 14,
  //     format: 'blockquote',
  //     type: 'block',
  //   },
  // ],
  [
    {
      id: 15,
      format: 'orderedList',
      type: 'block',
    },
    {
      id: 16,
      format: 'unorderedList',
      type: 'block',
    },
  ],
  [
    {
      id: 17,
      format: 'alignLeft',
      type: 'block',
    },
    {
      id: 18,
      format: 'alignCenter',
      type: 'block',
    },
    {
      id: 19,
      format: 'alignRight',
      type: 'block',
    },
  ],
  [
    {
      id: 20,
      format: 'link',
      type: 'link',
    },
    // {
    //   id: 21,
    //   format: "image",
    //   type: "embed",
    // },

    // {
    //   id: 23,
    //   type: "table",
    // },
  ],

  [
    {
      id: 24,
      type: 'inTable',
    },
  ],
  [
    {
      id: 25,
      format: 'colorScheme',
      type: 'color-dropdown',
    },
  ],
];

export default toolbarGroups;
